export default __webpack_public_path__ + "static/media/Game.8d6b2665.svg";